import { useState } from 'react';
const useInstitutionVerificationFormState = () => {
    const [message, setMessage] = useState('');
    const [file, setFile] = useState(null);
    return {
        formState: {
            message,
            setMessage,
            file,
            setFile,
        },
    };
};
export default useInstitutionVerificationFormState;
